import { FC, useMemo } from "react"

import { ActionBadge } from "components/risk/ActionBadge"
import { Column, DataTable } from "components/tables/DataTable"

import { ActionLog } from "services/risk/types"

import dayjs from "libs/dayjs"

interface Props {
  actions: ActionLog[]
}

export const RiskActionHistory: FC<Props> = ({ actions }) => {
  const columns = useMemo<Column<ActionLog>[]>(
    () => [
      { header: "Action", render: (log) => <ActionBadge action={log.action} /> },
      { header: "Rule", render: (log) => log.rule_name || "-" },
      {
        header: "Type",
        render: (log) => <span className="text-xs text-gray-500 dark:text-gray-400">{log.trigger_type}</span>
      },
      { header: "Executed", render: (log) => dayjs(log.created_at).format("DD.MM.YYYY h:mm A") }
    ],
    []
  )

  return (
    <div className="bg-white dark:bg-[#131421] border border-gray-200 dark:border-[rgba(255,255,255,0.1)] shadow-sm dark:shadow-none rounded-xl p-6">
      <h3 className="text-lg font-semibold mb-4">Action History</h3>
      <DataTable rows={actions} columns={columns} rowKey={(log) => log.id} />
    </div>
  )
}
